import { render, staticRenderFns } from "./SmsTemplateConfigIndex.vue?vue&type=template&id=ea45a12a&scoped=true"
import script from "./SmsTemplateConfigIndex.vue?vue&type=script&lang=js"
export * from "./SmsTemplateConfigIndex.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateConfigIndex.vue?vue&type=style&index=0&id=ea45a12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea45a12a",
  null
  
)

export default component.exports